import React, { useEffect, useRef, useState } from 'react';
import { FormPanelButtonType, FormRendererAPIType } from 'components/common/form';
import FormPanelButtonUpdateIndexes from 'components/common/form/top-control-panel/button-components/FormPanelButtonUpdateIndexes';
import { Box } from '@mui/material';
import useBundleTranslation from 'i18n';
import Alert from '@mui/material/Alert';
import IconHandler from 'components/common/icon/IconHandler';

export type InfoMessageType = 'none' | 'optimized' | 'full';
export function ReIndexRequiredLine({
    messageType,
    form,
    resetFields,
}: {
    messageType: InfoMessageType;
    form: FormRendererAPIType;
    resetFields: Array<string>;
}) {
    const { t } = useBundleTranslation('components/common/form/form');
    const triggerRef = useRef<any>();

    const [autoOpen, setAutoOpen] = useState(false);
    useEffect(() => {
        if (!triggerRef.current) {
            return;
        }
        if (messageType == 'full' && !autoOpen) {
            triggerRef.current.click();
            setAutoOpen(true);
        }
    }, [triggerRef.current, messageType]);
    if (messageType == 'none') {
        return null;
    }
    return (
        <Alert
            severity={'error'}
            icon={<IconHandler icon={{ type: 'mi', value: 'alert' }} />}
            variant={'standard'}
            sx={{ justifyContent: 'center' }}
        >
            {t('update_index_confirmation.warn_message.part_0')}
            <FormPanelButtonUpdateIndexes
                confirmationPopupContent={<Box>{t(`update_index_confirmation.${messageType}.content`)}</Box>}
                confirmationPopupTitle={t(`update_index_confirmation.${messageType}.title`)}
                triggerRef={triggerRef}
                extraUrlParams={messageType == 'full' ? { force: '1' } : undefined}
                button={
                    {
                        label: t('update_index_confirmation.warn_message.part_1'),
                        component: 'FormPanelButtonUpdateIndexes',
                        translationNS: 'app/admin/search',
                        props: {
                            alert_flag_component_name: resetFields,
                            getIndexStatusUrl: '/data/admin/search/get-index-status',
                            updateIndexUrl: '/data/admin/search/update-index',
                            cancelIndexUpdateUrl: '/data/admin/search/cancel-index-update',
                            isLink: true,
                        },
                    } as FormPanelButtonType<any>
                }
                buttonName={'updateIndex'}
                formActions={form}
                submitId={''}
                isSubMenuItem={false}
            />
            {t('update_index_confirmation.warn_message.part_2')}
        </Alert>
    );
}
